 export const ProjectName = "Therapy Diary App"